import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFlipOrientation.tsx
const IconFlipOrientation = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "#998e8e",
			fillRule: "evenodd",
			d: "M4 10.95a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2 0v5h10v-5z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#998e8e",
			d: "M11.172 4.95H8a6 6 0 0 0-6 6v4H0v-4a8 8 0 0 1 8-8h3.172L9.636 1.414 11.05 0 15 3.95 11.05 7.9 9.636 6.486z"
		})
	]
});
var IconFlipOrientation_default = forwardRef(IconFlipOrientation);
//#endregion
export { IconFlipOrientation_default as default };
